export function createVideoApi(baseUrl, getAuthHeaders) {
  return async (path, body, token, method) => {
    let response;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      response = await fetch(`${baseUrl.replace(/\/$/, '')}/video-support${path}`, {
      method: method || (body === undefined ? 'GET' : 'POST'),
      headers: { ...getAuthHeaders(), 'Content-Type': 'application/json', ...(token ? { 'X-Video-Token': token } : {}) },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
      cache: 'no-store',
      signal: controller.signal,
      });
    } catch (_) {
      const message = process.env.NODE_ENV === 'development'
        ? `Cannot reach video support at ${baseUrl}. Make sure the backend is running and this API URL is correct.`
        : 'Unable to connect to video support. Please check your connection and try again.';
      const error = new Error(message);
      error.status = 0;
      throw error;
    } finally { clearTimeout(timeout); }
    let result;
    try { result = await response.json(); } catch (_) { throw new Error('Video support is unavailable. Please try again.'); }
    if (!response.ok) { const error = new Error(result.error || (response.status === 404 ? 'Video support is not available on this server yet. Please contact support.' : 'Unable to complete the call request.')); error.status = response.status; throw error; }
    return result;
  };
}
export function saveCall(call) {
  sessionStorage.setItem(`video-support:${call.id}`, JSON.stringify({ id: call.id, token: call.token }));
  return call;
}
export function readCall(id) {
  try { return JSON.parse(sessionStorage.getItem(`video-support:${id}`)); } catch (_) { return null; }
}
